import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { singleArticle, subPageMv, articleHeader, articleBody } from '../styles/single.module.scss'
import ArticleTag from './articleTag'
import ArticleInfo from './articleInfo'
import ArticleFooter from './articleFooter'

export default function MainBlogPage({ article, currPostId, filterArticle }) {
  const { title, content, tags, slug, featuredImage } = article

  return (
    <div className="singlePage">
      <article className={singleArticle}>
        {featuredImage && (
          <div className={subPageMv}>
            <GatsbyImage image={featuredImage.gatsbyImageData} alt="cover image" />
          </div>
        )}
        <header className={articleHeader}>
          <h2 className="heading">{title}</h2>
          <ArticleInfo data={article} />
        </header>
        <div
          className={articleBody}
          dangerouslySetInnerHTML={{
            __html: content.childMarkdownRemark.html,
          }}
        />
        {tags && <ArticleTag tags={tags} slug={slug} />}
        <ArticleFooter data={article} currPostId={currPostId} filterArticle={filterArticle} />
      </article>
    </div>
  )
}
